// import React, { useCallback, useState } from "react";
// import elementValidation from '../Component/validation.js';
// import { FormJSONCreateContext } from '../Component/FormJSONCreateContext';
// import FormRenderer from '../Component/Forms/FormRenderer';
// import ThemeControls from "../Component/AllThemesControl";
// import { Form } from '../Component/Forms/formElement';
// import { MasterContext } from '../services/MasterContext';
// import { APIPOST, APIPATCH, APIGET } from '../services/APIServices';
// import { useNavigate } from 'react-router-dom';
// import Snackbar from '@mui/material/Snackbar';
// import Alert from '@mui/material/Alert';
// import { useLocation, useParams } from 'react-router-dom';

// function TabPanels({ formJSON, hendleErrorMsg, setPostResponse, key }) {
//   const { useStyles } = ThemeControls;
//   const classes = useStyles();
//   let apiSign = '/save'
//   const { contextJson, contextObjective, apiContextObj, setEditData } = React.useContext(FormJSONCreateContext);
 
//   function validateThisForm(jsonContext) {
//     let return_error = true;
//     jsonContext.fields.forEach(field => {
//       if (!elementValidation(field)) {
//         return_error = false;
//         return false;
//       }
//     });
//     return return_error;
//   }
//   function responseData(res){
//     console.log(res)
//     if(res.dataRecevied.data&&res.setPostResponse.statusCode==="SUCCESS"){
//       console.log(res.dataRecevied.data.accountvosid)
//       setPostResponse(res.dataRecevied.data.accountvosid, key)
//     }
//   }

//   async function postingData(contextJson, data) {
//     try {
//       const response = await APIPOST(apiContextObj.apiContextSave + apiSign, data, contextJson, responseData, hendleErrorMsg);
//       console.log("Response Data:", response);
//       if (response) {
//         return response.data
//       }
//     } catch (error) {
//       console.error(error);
//       throw error;
//     }
//   }


//   const handleSubmit = (event) => {
//     event.preventDefault();
//     const formData={}
//     let isFormValid = true;
//       isFormValid = validateThisForm(formJSON)
//     if(isFormValid){
//       formJSON.fields.forEach((thisField) => {
//         const { field_type, field_id, field_value} = thisField;
//         formData[field_id] = field_value;
//       })
//     console.log(formData)
//       if (contextObjective === "create") {
//       const data = postingData(contextJson, formData);
//       console.log(data)
//        } else if (contextObjective === "update") {
//         // updateData(contextJson, formData);
//        }
//     }else{
//       const msg = 'Please Check Form for errors!';
//       hendleErrorMsg(msg, 'error');
//     }


//   };
// console.log(formJSON)
//   return (
//     <div className={classes.formTabCard}>
//       <div className={classes.formTabheading}>
//         <div className="flexIcon">
//           <h1>{formJSON.page_label}</h1>
//         </div>
//         <></>
//       </div>
//       <FormRenderer formJSON={formJSON} />
//       <div className={classes.fromBtn}>
//         <button className="smtbtn" type="submit" disabled={formJSON.btn_disable} onClick={handleSubmit}>Submit</button>
//     </div>
//     </div>
//   );
// }

// function TabFormPart() {
//   const { useStyles } = ThemeControls;
//   const classes = useStyles();
//   const { contextJson } = React.useContext(FormJSONCreateContext);
//   const [open, setOpen] = useState(false);
//   const [errorMsg, setErrorMsg] = useState('');
//   const [msgtype, setMsgType] = useState('error');
//   const [response, setPostResponse] =useState([])

//   const hendleErrorMsg = useCallback((msg, type) => {
//     if (msg.statusCode === "Request made is not correct") {
//       alert(msg.serverMsg);
//     } else {
//       setOpen(true);
//       setErrorMsg(msg);
//       setMsgType(type)
//     }
//   }, [setOpen, setErrorMsg]);

//   const handleClose = useCallback(() => {
//     setOpen(false);
//   }, []);

//   // React.useEffect(()=>{
    
//   // },[response])

//   function updateResponseId(id, key) {
//     contextJson[key].btn_disable = true;
//     contextJson[key].fields.map((field) => {
//       if (field.field_id === "accountvosid") {
//         field.field_value = id;
//       }
//       return field;
//     });
//   }
// console.log(contextJson)

//   return (
//     <>
//       <Snackbar className={classes.errorpopup} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={open} autoHideDuration={3000} onClose={handleClose}>
//         <Alert onClose={handleClose} severity={msgtype} sx={{ width: '100%' }}>
//           {errorMsg}
//         </Alert>
//       </Snackbar>
//       {Object.keys(contextJson).map((key, index) => {
//         if (key !== "xioFEConfig") {
//           return (
//             <TabPanels
//               key={key}
//               setPostResponse={updateResponseId}
//               formJSON={contextJson[key]}
//               hendleErrorMsg={hendleErrorMsg}
//             />
//           );
//         }
//         return null;
//       })}
//     </>
//   );
// }

// export default TabFormPart;

import React, { useCallback, useState } from "react";
import elementValidation from '../Component/validation.js';
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext';
import FormRenderer from '../Component/Forms/FormRenderer';
import ThemeControls from "../Component/AllThemesControl";
import { Form } from '../Component/Forms/formElement';
import { MasterContext } from '../services/MasterContext';
import { APIPOST, APIPATCH, APIGET } from '../services/APIServices';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useLocation, useParams } from 'react-router-dom';

function TabPanels({ formJSON, hendleErrorMsg, setPostResponse, key }) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  let apiSign = '/save'
  const { contextJson, contextObjective, apiContextObj, contextDataArr,contextIndex } = React.useContext(FormJSONCreateContext);
 
  function validateThisForm(jsonContext) {
    let return_error = true;
    jsonContext.fields.forEach(field => {
      if (!elementValidation(field)) {
        return_error = false;
        return false;
      }
    });
    return return_error;
  }
  function responseData(res){
    console.log(res)
    if(res.dataRecevied.data && res.setPostResponse.statusCode === "SUCCESS"){
      let msg='Data successfully inserted!'
      hendleErrorMsg(msg, 'success')
      setPostResponse(res.dataRecevied.data.accountvosid, key)
    }
  }

  async function postingData(contextJson, data) {
    try {
      const response = await APIPOST(apiContextObj.apiContextSave + apiSign, data, contextJson, responseData, hendleErrorMsg);
      console.log("Response Data:", response);
      if (response) {
        return response.data
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function updateData(contextJson, data) {
    try {
      if (data) {
        const response = await APIPATCH(apiContextObj.apiContextSave + '/' + contextDataArr[contextIndex][apiContextObj.id], data, contextJson, responseData, hendleErrorMsg);
        if (response) {
          setPostResponse(response.data);
          return response.data;
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }


  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = {}
    let isFormValid = true;
    isFormValid = validateThisForm(formJSON)
    if (isFormValid) {
      formJSON.fields.forEach((thisField) => {
        const { field_type, field_id, field_value} = thisField;
        formData[field_id] = field_value;
      })
      console.log(formData)
      if (contextObjective === "create") {
        postingData(contextJson, formData);
      } else if (contextObjective === "update") {
        updateData(contextJson, formData);
      }
    } else {
      const msg = 'Please Check Form for errors!';
      hendleErrorMsg(msg, 'error');
    }
  };

  return (
    <div className={classes.formTabCard}>
      <div className={classes.formTabheading}>
        <div className="flexIcon">
          <h1>{formJSON.page_label}</h1>
        </div>
        <></>
      </div>
      <FormRenderer formJSON={formJSON} />
      <div className={classes.fromBtn}>
        <button className="smtbtn" type="submit" disabled={formJSON.btn_disable} onClick={handleSubmit}>Submit</button>
      </div>
    </div>
  );
}

function TabFormPart() {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const { contextJson } = React.useContext(FormJSONCreateContext);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [msgtype, setMsgType] = useState('error');
  const [response, setPostResponse] = useState([])
  const [masterJson, setMasterJson] = useState(contextJson)

  const hendleErrorMsg = useCallback((msg, type) => {
    if (msg.statusCode === "Request made is not correct") {
      alert(msg.serverMsg);
    } else {
      setOpen(true);
      setErrorMsg(msg);
      setMsgType(type)
    }
  }, [setOpen, setErrorMsg]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  function updateResponseId(id, key) {
    const updatedContextJson = { ...contextJson };
    updatedContextJson[key].btn_disable = true;
    updatedContextJson[key].fields = updatedContextJson[key].fields.map((field) => {
      if (field.field_id === "accountvosid") {
        return { ...field, field_value: id };
      }
      return field;
    });
    setMasterJson(updatedContextJson);
  }

  return (
    <>
      <Snackbar className={classes.errorpopup} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={msgtype} sx={{ width: '100%' }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {Object.keys(masterJson).map((key, index) => {
        if (key !== "xioFEConfig") {
          return (
            <TabPanels
              key={key}
              setPostResponse={updateResponseId}
              formJSON={masterJson[key]}
              hendleErrorMsg={hendleErrorMsg}
            />
          );
        }
        return null;
      })}
    </>
  );
}

export default TabFormPart;
